export class BusinessSubscriptionNameToDisplayViewModel {
    public culture: string;
    public name: string;

    constructor(culture: string, name: string) {
        this.culture = culture;
        this.name = name;
    }
}
